import axios from "axios";
import Constants from "@/services/Constants";

export default {

	async getNews(id) {
		let res = await axios.get(`${Constants.backend}/news/${id}/`);
		return res.data;
	}
}